/**
 * 프랜차이즈 브랜드 계약 상태 — 화면 공통 SoT (2026-09-02).
 *
 * status: "active"(진행 중) | "ended"(계약종료 — 더 이상 공사하지 않음).
 * ⚠삭제(active=false, 휴지통)와 다른 축이다. 종료 브랜드는 목록에 남고
 *   기존 견적도 그대로 열람·복사된다 — 표기만 분리한다.
 * BE 미러: iggg-estimate/franchise_brand_api.py (_merge_defaults / BrandUpdate.status)
 *
 * ⚠BrandsPage 가 아니라 이 작은 모듈에 둔다 — 대시보드·허브가 BrandsPage 를
 *   import 하면 무거운 BrandEditModal 이 그 청크로 딸려온다.
 */

/** 필드 없는 기존 브랜드는 진행 중(BE _merge_defaults 와 동일 규약). */
export function isBrandEnded(brand) {
  return (brand?.status || "active") === "ended";
}

/** ISO 날짜 → 'YYYY.MM.DD' (없으면 빈 문자열). */
export function fmtBrandEndedDay(iso) {
  const s = String(iso || "");
  if (s.length < 10) return "";
  return `${s.slice(0, 4)}.${s.slice(5, 7)}.${s.slice(8, 10)}`;
}
